// ui
export const SET_UI_STATE = 'ui/SET_UI_STATE';
export const SET_FILE_UPLOAD_STATE = 'ui/SET_FILE_UPLOAD_STATE';
export const SET_FILE_DOWNLOAD_STATE = 'ui/SET_FILE_DOWNLOAD_STATE';

export const CONFIRM_MODAL = 'ui/CONFIRM_MODAL';
export const OK_CONFIRM_MODAL = 'ui/OK_CONFIRM_MODAL';
export const CANCEL_CONFIRM_MODAL = 'ui/CANCEL_CONFIRM_MODAL';

export const OPEN_EXERCISE_PICKER = 'ui/OPEN_EXERCISE_PICKER';
export const SELECT_EXERCISE_PICKER = 'ui/SELECT_EXERCISE_PICKER';
export const CANCEL_EXERCISE_PICKER = 'ui/CANCEL_EXERCISE_PICKER';

export const REQUEST_UPLOAD_DOCUMENTS = 'ui/REQUEST_UPLOAD_DOCUMENTS';
export const CANCEL_UPLOAD_FILES = 'ui/CANCEL_UPLOAD_FILES';

export const REQUEST_DOWNLOAD_DOCUMENT = 'ui/REQUEST_DOWNLOAD_DOCUMENT';

export const SEARCH_VIDEO_MODAL = 'ui/SEARCH_VIDEO_MODAL';
export const REQUEST_UPLOAD_VIDEOS = 'ui/REQUEST_UPLOAD_VIDEOS';
export const ASSIGN_SEARCH_VIDEO_MODAL = 'ui/ASSIGN_SEARCH_VIDEO_MODAL';
export const ON_UPLOADED_VIDEO_SUCCESS = 'ui/ON_UPLOADED_VIDEO_SUCCESS';
export const CANCEL_SEARCH_VIDEO_MODAL = 'ui/CANCEL_SEARCH_VIDEO_MODAL';

export const MOVE_ENTITY_MODAL = 'ui/MOVE_ENTITY_MODAL';
export const CANCEL_MOVE_ENTITY_MODAL = 'ui/CANCEL_MOVE_ENTITY_MODAL';
export const SELECT_MOVE_ENTITY_MODAL = 'ui/SELECT_MOVE_ENTITY_MODAL';

export const REQUEST_SEND_MESSAGE = 'conversations/REQUEST_SEND_MESSAGE';

export const SWITCH_BOOKMARK_WORKOUT = 'ui/SWITCH_BOOKMARK_WORKOUT';
